import * as React from "react";
import DataSource from "../lib/DataSource";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { util } from "../lib/Util";
import "../css/student.css";
import { Link } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import { exportToExcel } from "../lib/exportExcel";
const { Option } = Select;

export default class FinanceList extends React.Component<
  {},
  {
    data: any;
    pagination: { current: number; pageSize: number; total: number };
    loading: boolean;
    filter: any;
    courseList: any;
  }
> {
  contentType = "finance";

  columns = [
    { title: "Student No.", dataIndex: "student_no", key: "student_no" },
    { title: "First Name", dataIndex: "firstname", key: "firstname" },
    { title: "Last Name", dataIndex: "lastname", key: "lastname" },
    { title: "Email", dataIndex: "email", key: "email" },
    {
      title: "Balance",
      render: (record) => <span>{record.balance.toLocaleString()}</span>,
    },
    {
      title: "Operation",
      key: "operation",
      render: (text, record) => {
        return (
          <Space size="small">
            <Link to={"/finance/records/" + record.student_id}>Detail</Link>
            <Link to={"/finance/records/" + record.student_id + "/add"}>
              Add Record
            </Link>
          </Space>
        );
      },
    },
  ];
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: { current: 1, pageSize: 20, total: 20 },
      loading: true,
      filter: {
        course: "",
        balance: false,
        intake: "",
        studentNo: "",
        firstname: "",
        lastname: "",
      },
      courseList: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  onFilterChange(key, value) {
    console.log(key, value);
    let filter = this.state.filter;
    filter[key] = value;

    this.setState({ filter: filter }, () => {
      this.loadData();
    });
  }

  loadData() {
    this.setState({ loading: true });
    let filter = this.state.filter;
    console.log(filter);
    let pagination = this.state.pagination;

    DataSource.loadFinanceListData(
      {
        intake: filter.intake ? filter.intake : null,
        balance: filter.balance ? 1 : 0,
        studentNo: filter.studentNo,
        course: filter.course,
        firstname: filter.firstname,
        lastname: filter.lastname,
      },
      (pagination.current - 1) * pagination.pageSize,
      pagination.pageSize,
    ).then((data) => {
      const pagination = this.state.pagination;
      pagination.total = data.count;
      this.setState({
        data: data,
        pagination: pagination,
        loading: false,
      });
    });

    if (!this.state.courseList) {
      FetchWithAuth(
        "content/list/course?parent=468&level=1&sortby=c.name%20asc&limit=100",
      ).then((data) => {
        this.setState({ courseList: data.data.list });
      });
    }
  }

  download() {
    const filter = this.state.filter;
    DataSource.loadFinanceListData({
      course: filter.course ? filter.course : null,
      intake: filter.intake ? filter.intake : null,
      balance: filter.balance ? 1 : 0,
      studentNo: filter.studentNo,
      firstname: filter.firstname,
      lastname: filter.lastname,
    }).then((data) => {
      exportToExcel(
        data.list,
        [
          { label: "Student No.", value: "student_no" },
          { label: "First Name", value: "firstname" },
          { label: "Last Name", value: "lastname" },
          { label: "Telephone", value: "telephone" },
          {
            label: "Course",
            value: (row) =>
              this.state.courseList?.find((item) => item.id === row.course)
                ?.name ?? "",
          },
          { label: "Email", value: "email" },
          { label: "Balance", value: "balance" },
        ],
        "Finance List",
        "Finance List",
      );
    });
  }

  onTableChange(pagination) {
    this.setState({ pagination: pagination }, () => {
      this.loadData();
    });
  }

  render() {
    const { data, pagination, loading, filter } = this.state;
    let intakes = util.intakes();
    let courses = this.state.courseList;

    if (!courses) {
      return (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <span>
            <i
              className="anticon anticon-loading"
              style={{ fontSize: 36, color: "#1890ff" }}
            />
          </span>
        </div>
      );
    }

    return (
      <div>
        <h2>Fees</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/finance/list">Fee</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>List</Breadcrumb.Item>
        </Breadcrumb>

        <br />

        <Row>
          <Col span={8}>
            <Form.Item label="Course">
              <Select
                defaultValue={this.state.filter.course}
                style={{}}
                defaultActiveFirstOption={true}
                onChange={(value) => this.onFilterChange("course", value)}
              >
                <Option value="" key={0}>
                  All
                </Option>
                {courses.map((course, index) => (
                  <Option value={course.id} key={index + 1}>
                    {course.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="&nbsp;Intake">
              <Select
                defaultValue={this.state.filter.intake}
                style={{ width: 100 }}
                defaultActiveFirstOption={true}
                onChange={(value) => this.onFilterChange("intake", value)}
              >
                <Option value="" key={0}>
                  All
                </Option>
                {intakes.map((intake, index) => (
                  <Option value={intake} key={index + 1}>
                    {intake}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Checkbox
              onChange={(event) =>
                this.onFilterChange("balance", event.target.checked)
              }
              defaultChecked={filter.balance}
            >
              Balance &gt; 0
            </Checkbox>
          </Col>

          <Col span={4}>
            <Space>
              <Link to="/import/finance-records">
                <i className="icon fas fa-upload"></i>Import
              </Link>
              <Button onClick={this.download.bind(this)}>Download</Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={4}>
            <Row>
              <Col span={20}>
                <Input
                  placeholder="Student No."
                  onChange={(event) =>
                    this.onFilterChange("studentNo", event.target.value)
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Row>
              <Col span={20}>
                <Input
                  placeholder="Firstname"
                  onChange={(event) =>
                    this.onFilterChange("firstname", event.target.value)
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col span={4}>
            <Row>
              <Col span={20}>
                <Input
                  placeholder="Lastname"
                  onChange={(event) =>
                    this.onFilterChange("lastname", event.target.value)
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <Table
          columns={this.columns}
          dataSource={data.list}
          pagination={pagination}
          loading={loading}
          size="small"
          onChange={this.onTableChange.bind(this)}
        />
      </div>
    );
  }
}
